export class Workout {
    public name: string = "";      
    public id: string = "";
    public drillId: string = "";
}